export default "__VITE_ASSET__a38aaab9__"